import { experimentsFlags, CalendarFilterVariants } from './config';
import {
  checkExperimentVariant,
  checkCachedExperimentVariant,
  getCurrentVariant,
} from './lib';

export const amplitudeExperiment = {
  lib: {
    checkExperimentVariant,
    checkCachedExperimentVariant,
    getCurrentVariant,
  },
  config: {
    flags: experimentsFlags,
    variants: {
      CalendarFilterVariants,
    },
  },
};
